"use client";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useTranslations } from "../../../helpers/translations";
import React, { useState } from "react";
import { useUserContext } from "../../../providers/UserProvider";
import { Locale } from "../../../services/graphql/shared/Base";
import { navIconButtonClass } from "./navIconButtonClass";
import { CurrentRegionIcon } from "./user-menu/CurrentRegionIcon";
import { DropdownMenuItemSelect } from "./user-menu/DropdownMenuItemSelect";
import { LocaleSelector } from "./user-menu/LocaleSelector";
import { RegionSelector } from "./user-menu/RegionSelector";

export const LocalizationNavbarMenu = () => {
  const { userPreferredLocalization } = useUserContext();
  const [lastSelectedLocale, setLastSelectedLocale] = useState<
    Locale | undefined
  >(undefined);
  const t = useTranslations("nav.userMenu.localization");

  const regionCode =
    userPreferredLocalization.data?.userPreferredLocalization
      .geographicalRegionCode ?? "CA";

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className={navIconButtonClass}
          aria-label={t("navbarAriaLabel")}
        >
          <CurrentRegionIcon
            code={regionCode}
            className="size-3xl object-contain opacity-60 transition-opacity group-hover:opacity-100"
          />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[240px]">
        <DropdownMenuItemSelect>
          <RegionSelector lastSelectedLocale={lastSelectedLocale} />
        </DropdownMenuItemSelect>
        <DropdownMenuItemSelect>
          <LocaleSelector
            lastSelectedLocale={lastSelectedLocale}
            setLastSelectedLocale={setLastSelectedLocale}
          />
        </DropdownMenuItemSelect>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
